export const BESPOKES = 'BESPOKES'
export const BESPOKE = 'BESPOKE'
export const BESPOKE_REMOVE = 'BESPOKE_REMOVE'
export const BESPOKE_UPDATE = 'BESPOKE_UPDATE'

export default {
    BESPOKES,
    BESPOKE,
    BESPOKE_REMOVE,
    BESPOKE_UPDATE,
}
